import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../lib/i18next";
import { getReactHookFormNestedError } from "../../utils/errors";
import { Controller, useController } from "react-hook-form";
import _ from "lodash";
import Button from "../Buttons/Button";
import {
  BUTTON_CREATE_TEMPLATE,
  BUTTON_EDIT,
  FIELD_REQUIRED,
} from "../../i18n/keysTranslations";
import ModalMessageTemplate from "./ModalMessageTemplate";
import MessageTemplatePreview, {
  getIsUnsupportedMessageTemplate,
} from "./MessageTemplatePreview";

const MessageTemplateContainer = ({
  name,
  control,
  errors = {},
  disabled = false,
}) => {
  const {
    field: { value, onChange },
  } = useController({
    control,
    name,
    defaultValue: "",
  });
  const [modalTemplateOpen, setModalTemplateOpen] = useState(false);
  const { t } = useTranslationApp();
  const error = getReactHookFormNestedError(errors, name);

  const onToggleModalTemplate = () => setModalTemplateOpen((prev) => !prev);

  const isEmptyTemplate = _.isEmpty(value);
  // Templates created outside the platform cannot be edited here: any rebuild
  // would drop data we do not understand, so we keep them read-only.
  const isUnsupportedTemplate = getIsUnsupportedMessageTemplate(value);

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: {
          value: true,
          message: t(FIELD_REQUIRED),
        },
      }}
      render={() => (
        <Box id={name}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            {!isEmptyTemplate && (
              <Box sx={{ mt: 1, width: "100%" }}>
                <MessageTemplatePreview value={value} />

                {!disabled && !isUnsupportedTemplate && (
                  <Button
                    color="secondary"
                    type="button"
                    onClick={onToggleModalTemplate}
                  >
                    {t(BUTTON_EDIT)}
                  </Button>
                )}
              </Box>
            )}
            {isEmptyTemplate && (
              <Button
                color="secondary"
                type="button"
                onClick={onToggleModalTemplate}
                disabled={disabled}
              >
                {t(BUTTON_CREATE_TEMPLATE)}
              </Button>
            )}
          </Box>
          {error?.message && (
            <Typography variant="body2" color="error">
              {error.message}
            </Typography>
          )}
          {modalTemplateOpen && (
            <ModalMessageTemplate
              modalOpen={modalTemplateOpen}
              onCloseModal={onToggleModalTemplate}
              data={value}
              onCallbackSave={(data) => {
                onChange(data);
              }}
            />
          )}
        </Box>
      )}
    />
  );
};

export default MessageTemplateContainer;
